import { render } from "./ListMessageTemplate.vue?vue&type=template&id=66472720&scoped=true"
import script from "./ListMessageTemplate.vue?vue&type=script&lang=js"
export * from "./ListMessageTemplate.vue?vue&type=script&lang=js"

import "./ListMessageTemplate.vue?vue&type=style&index=0&id=66472720&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66472720"]])

export default __exports__